import { listarVariaveisObservacao, selecionarFormulasPorCriterio } from '@shared/components/formula/utils/formula-contexto.util';
import { coletarEstadosFormulas } from '@shared/components/formula/utils/formula-estados.util';
import { planejarTrocaCodigoFormulas } from '@shared/components/formula/utils/troca-codigo-formulas.util';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmModalComponent } from '@shared/components/confirm-modal/confirm-modal.component';
import { AtivacaoSectionCardComponent } from '@shared/components/ativacao-section-card/ativacao-section-card.component';
import { IcmsTributoObservacoesSectionComponent } from './sections/tributo-observacoes-section/tributo-observacoes-section.component';
import { IcmsTributoObservacoesFiscoSectionComponent } from './sections/tributo-observacoes-fisco-section/tributo-observacoes-fisco-section.component';
import { IcmsTributoRegraSectionComponent, MAPA_CAMPOS_ICMS_NATUREZA } from './sections/tributo-regra-section/tributo-regra-section.component';
import { IcmsTributoExcecoesSectionComponent } from './sections/tributo-excecoes-section/tributo-excecoes-section.component';
import { FormulaEditorDialogComponent, FormulaEditorDialogData, FormulaEditorDialogResult } from '@shared/components/formula/formula-editor-dialog/formula-editor-dialog.component';
import { VariaveisDisponiveisDialogComponent, VariaveisDisponiveisDialogData, VariaveisCursorPayload } from '@shared/components/formula/variaveis-disponiveis-dialog/variaveis-disponiveis-dialog.component';
import { CstIcmsStruct } from '@shared/services/structs/motor-fiscal/cst-icms.struct';
import { LookupItemStruct } from '@shared/services/structs/motor-fiscal/lookup-item.struct';
import { ModalidadeBcOption } from '@shared/services/structs/motor-fiscal/modalidade-bc-option.struct';
import { NaturezaOperacaoIcmsExcecaoPendenteStruct } from '@shared/services/structs/motor-fiscal/natureza-operacao-icms-excecao-pendente.struct';
import { FormulaItemStruct } from '@shared/services/structs/formula/formula-item.struct';
import { FormulaCatalogoItemStruct } from '@shared/services/structs/formula/formula-catalogo-item.struct';
import { FormulaCatalogoService } from '@shared/services/apis/motor-fiscal/formula-catalogo.service';
import { VariavelStruct } from '@shared/services/structs/formula/variavel.struct';
import { TipoFormulaEnum } from '@shared/enums/formula/tipo-formula.enum';
import { TipoOperacaoEnum } from '@shared/enums/motor-fiscal/tipo-operacao.enum';
import {
    aplicarObrigatoriedadeIndicadores,
    controlesDasRegrasEntreCampos,
    lerIndicadoresCst,
} from '@shared/constants/motor-fiscal/indicadores-campos.util';
import { environment } from '../../../../../../../environments/environment';

@Component({
    selector: 'app-natureza-operacao-icms-tab',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        AtivacaoSectionCardComponent,
        IcmsTributoRegraSectionComponent,
        IcmsTributoObservacoesSectionComponent,
        IcmsTributoObservacoesFiscoSectionComponent,
        IcmsTributoExcecoesSectionComponent,
    ],
    templateUrl: './natureza-operacao-icms-tab.component.html',
    styleUrl: './natureza-operacao-icms-tab.component.css',
})
export class NaturezaOperacaoIcmsTabComponent implements OnInit {
    @Input({ required: true }) form!: FormGroup;
    @Input() codigoTributos: CstIcmsStruct[] = [];
    @Input() modalidadesBc: ModalidadeBcOption[] = [];
    @Input() modalidadesBcSt: ModalidadeBcOption[] = [];
    @Input() motivosDesoneracaoIcms: LookupItemStruct[] = [];
    @Input() motivosReducaoAdRem: LookupItemStruct[] = [];
    @Input() formulasIcms: FormulaCatalogoItemStruct[] = [];
    @Input() estadosFormulas: FormulaItemStruct[] = [];
    @Input() idNaturezaOperacao: number | null = null;
    @Input() excecoesPendentes: NaturezaOperacaoIcmsExcecaoPendenteStruct[] = [];
    @Output() excecoesChange = new EventEmitter<NaturezaOperacaoIcmsExcecaoPendenteStruct[]>();

    public cfopLookupUrl = environment.urlApiMotorFiscal + 'Lookup/cfop';
    private cstAnterior: string | null = null;
    private restaurandoCst = false;

    ngOnInit(): void {
        this.isAtivoControl.valueChanges.subscribe(() => this.sincronizarObrigatoriedade());
        this.cstAnterior = this.cstIcmsValue;
        this.icmsForm.get('cstIcms')?.valueChanges.subscribe(cst => {
            // Roda antes da seção limpar os campos que o novo CST não exibe: guarda o estado para o cancelar.
            const valoresAntesDaTroca = { ...this.icmsForm.getRawValue(), cstIcms: this.cstAnterior };
            this.sincronizarObrigatoriedade();
            this.confirmarTrocaCst(cst, valoresAntesDaTroca);
        });
        controlesDasRegrasEntreCampos(MAPA_CAMPOS_ICMS_NATUREZA).forEach(nome =>
            this.icmsForm.get(nome)?.valueChanges.subscribe(() => this.sincronizarObrigatoriedade()));
        this.sincronizarObrigatoriedade();
    }

    /** CST exigido com o ICMS ligado; os campos do CST, pelo indicador do catálogo. */
    private sincronizarObrigatoriedade(): void {
        const ativo = !!this.isAtivoControl.value;
        const cst = this.icmsForm.get('cstIcms')?.value;
        this.aplicarObrigatorio(this.icmsForm.get('cstIcms'), ativo);
        const indicadores = ativo && cst ? lerIndicadoresCst(this.codigoTributos.find(c => c.codigo === cst)?.indicadores) : null;
        aplicarObrigatoriedadeIndicadores(this.icmsForm, indicadores, MAPA_CAMPOS_ICMS_NATUREZA);
    }

    private aplicarObrigatorio(control: import('@angular/forms').AbstractControl | null | undefined, obrigatorio: boolean): void {
        if (!control) return;
        if (obrigatorio) {
            control.addValidators(Validators.required);
        } else {
            control.removeValidators(Validators.required);
        }
        control.updateValueAndValidity({ emitEvent: false });
    }

    public get icmsForm(): FormGroup {
        return this.form.get('icms') as FormGroup;
    }

    public get isAtivoControl(): FormControl {
        return this.icmsForm.get('isAtivo') as FormControl;
    }

    public get cstIcmsValue(): string | null {
        return this.icmsForm?.get('cstIcms')?.value ?? null;
    }

    /** Tipo de operação da natureza (Entrada/Saida), lido do form raiz. */
    public get tipoOperacaoValue(): TipoOperacaoEnum {
        return this.form?.get('tipoOperacao')?.value ?? TipoOperacaoEnum.Saida;
    }

    public get formulasParaCst(): FormulaCatalogoItemStruct[] {
        return this.formulasParaCodigo(this.cstIcmsValue);
    }

    private formulasParaCodigo(codigo: string | null): FormulaCatalogoItemStruct[] {
        if (!codigo) return this.formulasIcms;
        return selecionarFormulasPorCriterio(this.formulasIcms, 'cst_icms', codigo);
    }

    /** Fonte única em memória das fórmulas: o FormGroup, que o salvar() também lê.
        O @Input estadosFormulas serve só de seed inicial (o pai já popula o control). */
    private get estadosFormulasMemoria(): FormulaItemStruct[] {
        return (this.icmsForm.get('_estadosFormulas')?.value as FormulaItemStruct[]) ?? [];
    }

    public get personalizadasCount(): number {
        return this.estadosFormulasMemoria.filter(e => e.tipo === TipoFormulaEnum.Personalizada).length;
    }

    /** Variáveis únicas (por tag) disponíveis nas fórmulas do ICMS. */
    public get variaveisUnicas(): VariavelStruct[] {
        return listarVariaveisObservacao(this.formulasParaCst);
    }

    constructor(
        private dialog: MatDialog,
        private formulaCatalogoService: FormulaCatalogoService,
    ) {}

    private confirmarTrocaCst(novoCst: string | null, valoresAntesDaTroca: Record<string, unknown>): void {
        if (this.restaurandoCst || novoCst === this.cstAnterior) return;

        const formulasAntigas = this.formulasParaCodigo(this.cstAnterior);
        const formulasNovas = this.formulasParaCodigo(novoCst);
        const plano = planejarTrocaCodigoFormulas(this.estadosFormulasMemoria, formulasAntigas, formulasNovas, {
            observacao: this.icmsForm.get('observacao')?.value,
            observacaoFisco: this.icmsForm.get('observacaoFisco')?.value,
        });

        if (plano.estadosParaRestaurar.length === 0 && plano.variaveisPendentes.length === 0) {
            this.cstAnterior = novoCst;
            return;
        }

        const partes = [`A troca para CST ${novoCst ?? 'não informado'}`];
        if (plano.estadosParaRestaurar.length > 0) {
            partes.push(`restaurará ${plano.estadosParaRestaurar.length} configuraç${plano.estadosParaRestaurar.length === 1 ? 'ão' : 'ões'} de fórmulas`);
        }
        if (plano.variaveisPendentes.length > 0) {
            partes.push(`deixará pendentes as variáveis [${plano.variaveisPendentes.map(nome => `{${nome}}`).join(', ')}] nas observações`);
        }

        const dialogRef = this.dialog.open(ConfirmModalComponent, {
            data: {
                title: 'Confirmar troca de CST',
                description: `${partes.join(' e ')}. Deseja continuar?`,
                buttonConfirm: 'Continuar',
                buttonClose: 'Cancelar',
            },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (!result?.confirm) {
                this.restaurandoCst = true;
                this.icmsForm.patchValue(valoresAntesDaTroca, { emitEvent: false });
                this.restaurandoCst = false;
                this.sincronizarObrigatoriedade();
                return;
            }

            this.icmsForm.get('_estadosFormulas')?.setValue(
                this.estadosFormulasMemoria.filter(estado => !plano.estadosParaRestaurar.includes(estado)));
            Object.entries(plano.observacoes).forEach(([campo, valor]) =>
                this.icmsForm.get(campo)?.setValue(valor));
            this.cstAnterior = novoCst;
        });
    }

    public abrirEditorFormulas(): void {
        const cst = this.codigoTributos.find(c => c.codigo === this.cstIcmsValue);
        const data: FormulaEditorDialogData = {
            titulo: ['ICMS', this.cstIcmsValue, cst?.descricao].filter(Boolean).join(' - '),
            formulas: this.formulasParaCst.map(formula => ({
                ...formula,
                variaveis: (formula.variaveisPermitidas ?? formula.variaveis),
            })),
            estadosIniciais: this.estadosFormulasMemoria as any[],
            estadosFormulasAgregados: coletarEstadosFormulas(this.form),
            contextoRaiz: 'natureza-operacao',
            validarPersonalizacoes: request => this.formulaCatalogoService.validarPersonalizacoes(request),
        };

        const ref = this.dialog.open(FormulaEditorDialogComponent, {
            width: '900px',
            maxWidth: '96vw',
            maxHeight: '92vh',
            data,
        });

        ref.afterClosed().subscribe((result: FormulaEditorDialogResult | null) => {
            if (result) {
                this.icmsForm.get('_estadosFormulas')?.setValue(result.formulas);
            }
        });
    }

    public abrirVariaveisDisponiveis(payload: VariaveisCursorPayload): void {
        const editor = payload.editor;
        const data: VariaveisDisponiveisDialogData = {
            variaveis: this.variaveisUnicas,
            targetControl: payload.control,
            cursorStart: payload.selectionStart,
            cursorEnd: payload.selectionEnd,
            onInsert: editor ? (v: VariavelStruct) => editor.inserirVariavel(v) : undefined,
        };

        this.dialog.open(VariaveisDisponiveisDialogComponent, {
            width: '820px',
            maxWidth: '96vw',
            maxHeight: '90vh',
            data,
        });
    }
}
